import { FC } from 'react';
import { Text } from './FormText.styled';

const FormText: FC = ({ children }) => <Text>{children}</Text>;

export { FormText };
